import { render } from "./SidebarNav.vue?vue&type=template&id=c8af9a50&scoped=true&ts=true"
import script from "./SidebarNav.vue?vue&type=script&lang=ts"
export * from "./SidebarNav.vue?vue&type=script&lang=ts"

import "./SidebarNav.vue?vue&type=style&index=0&id=c8af9a50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8af9a50"]])

export default __exports__